import * as types from '../../constants/event/eventPartnerConstants';

export const eventPartnerCreateRequest = ({
  partnerEmail,
  invCode,
  callback,
  error,
}) => ({
  type: types.EVENT_PARTNER_CREATE_REQUEST,
  partnerEmail,
  invCode,
  callback,
  error,
});

export const eventPartnerUpdateRequest = ({
  partnerAccountNo,
  invCode,
  enabled,
  callback,
  error,
}) => ({
  type: types.EVENT_PARTNER_UPDATE_REQUEST,
  partnerAccountNo,
  invCode,
  enabled,
  callback,
  error,
});

export const eventPartnerListRequest = ({
  page,
  pageLength,
  callback,
  error,
}) => ({
  type: types.EVENT_PARTNER_LIST_REQUEST,
  page,
  pageLength,
  callback,
  error,
});

export const eventPartnerDetailsRequest = ({
  accountNo,
  callback,
  error,
}) => ({
  type: types.EVENT_PARTNER_DETAILS_REQUEST,
  accountNo,
  callback,
  error,
});

export const eventPartnerRewardListRequest = ({
  invNo,
  callback,
  error,
}) => ({
  type: types.EVENT_PARTNER_REWARD_LIST_REQUEST,
  invNo,
  callback,
  error,
});
